export default __webpack_public_path__ + "static/media/add-square.49b6ba07.svg";